import { formatNumber } from "~vue/utils/formatNumber";
import { MARKDOWN_EXTENSIONS } from "~vue/utils/markdownFileUpload";

export const DOCUMENT_FILE_EXTENSIONS = [".txt", ".csv", ".pdf", ".docx", ".xlsx", ".pptx", ...MARKDOWN_EXTENSIONS];
export const IMAGE_FILE_EXTENSIONS = [".jpg", ".jpeg", ".png", ".webp", ".gif"];

export function getAcceptedFileTypes(includeImages: boolean): string {
    return (includeImages ? [...DOCUMENT_FILE_EXTENSIONS, ...IMAGE_FILE_EXTENSIONS] : DOCUMENT_FILE_EXTENSIONS).join(",");
}

export function formatAcceptedFileTypes(acceptedFileTypes: string): string {
    const labels = acceptedFileTypes.split(",").map((extension) => {
        const normalized = extension.trim().toLowerCase();
        if (MARKDOWN_EXTENSIONS.includes(normalized)) {
            return "Markdown";
        }
        if (normalized === ".jpg" || normalized === ".jpeg") {
            return "JPEG";
        }
        return normalized.replace(/^\./, "").toUpperCase();
    });
    return [...new Set(labels)].filter(Boolean).join(", ");
}

export interface OversizedFile {
    file: File;
    limit: number;
}

function formatFileSizeLimit(limit: number): string {
    const megabytes = limit / (1024 * 1024);
    return `${formatNumber(megabytes, "up-to-one-decimal")}MB`;
}

export function formatOversizedFiles(files: OversizedFile[]): string {
    return files.map(({ file, limit }) => `${file.name} (${formatFileSizeLimit(limit)} limit)`).join(", ");
}
